<template>
  <!-- SLIDER -->
  <section class="image_cabecera">
    <img src="@/assets/img/slider1.jpg" />
    <div class="row">
      <div class="col col-6 wrap-text">
        <div class="text">
          <h3>Murcia Barroca</h3>
          <h2>Actividades</h2>
        </div>
      </div>
    </div>
    <div class="row wmax slider-controls">
      <div class="col col-6">
        <a @click="$router.go(-1)"><img src="@/assets/img/flecha_left.svg" width="30" /> ATRÁS</a>
      </div>
    </div>
  </section>
  <!-- .SLIDER -->
  <!-- INTRO -->
  <section class="wmax pt-6 pb-5">
    <div class="row pb-5">
      <div class="col col-8">
        <h2>Actividades</h2>
        <p>
          Descubre la riqueza de Murcia Barroca a través de nuestra agenda de actividades. Un viaje fascinante que te llevará a través del tiempo, explorando la belleza y la historia que se esconde en
          cada rincón de nuestra querida Murcia. Desde exposiciones y conferencias hasta talleres y recorridos, cada actividad ha sido cuidadosamente seleccionada para iluminar la época barroca de una
          manera accesible y atractiva. Sumérgete en la cultura, el arte y la arquitectura que definen a Murcia Barroca. ¡Te esperamos!
        </p>
      </div>
      <div class="col col-4"><v-calendar :attributes="attrs" @dayclick="onDayClick" expanded /></div>
    </div>
    <div class="row actividades-lista">
      <div class="col col-12">
        <div v-for="(actividades, fecha) in actividadesPorDia" :key="fecha" :id="fecha" class="actividad-item">
          <h2>{{ fecha.split("-").reverse().join("/") }}</h2>
          <!-- Formato 'dd/mm/aaaa' -->
          <div class="actividad" v-for="actividad in actividades" :key="actividad.id">
            <div class="row">
              <div class="col col-12 estado_aforo" v-if="actividad.estado_aforo == 0"><span>AFORO COMPLETO</span></div>
              <div class="col col-xs-12 col-8">
                <h3>{{ actividad.titulo }}</h3>
                <p>{{ actividad.descripcion }}</p>
              </div>
              <div class="col col-xs-12 col-4 datos_actividad">
                <p><strong>Horario:</strong> {{ actividad.horario }}</p>
                <p><strong>Lugar/encuentro:</strong> {{ actividad.lugar_celebracion }}</p>

                <p v-if="actividad.estado_aforo == 0"><strong>Acceso:</strong> <span style="text-decoration: underline">AFORO COMPLETO</span></p>
                <p v-else><strong>Acceso:</strong> {{ actividad.acceso }}</p>

                <p><strong>Tipo:</strong> {{ actividad.categoria }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<div class="col col-4"><v-calendar :attributes="attrs" @dayclick="onDayClick" expanded /></div>
<script>
  import axios from "axios";
  //import { watch } from 'vue';
  export default {
    data() {
      return {
        actividades: [],
        loading: true,
        totalActividades: 0,
        actividadesPorDia: {},
        attrs: [
          {
            key: "today",
            highlight: "red",
            dot: "red",
            order: 3,
            contentStyle: {
              color: "#fafafa", // Color del texto del día actual
              backgroundColor: "#8b2119", // Color de fondo del día actual
            },
            dates: new Date(),
          },
          {
            key: "event",
            dot: "transparent",
            dates: [new Date(2023, 10, 11), new Date(2023, 10, 10), new Date(2023, 10, 17)],
            contentStyle: {
              color: "#fafafa", // Color del texto de los días del evento
            },
            highlight: {
              color: "red",
              fillMode: "light",
            },
          },
        ],
      };
    },
    created() {
      this.loadLugares();
    },
    methods: {
      loadLugares() {
        axios
          .get(`https://murciabarroca.es/api/getActividades`)
          .then((response) => {
            this.actividades = response.data.data;
            this.totalActividades = this.actividades.length;
            console.log(this.actividades);

            const fechasDeActividades = this.actividades.map((actividad) => new Date(actividad.fecha));

            // Agrupar las actividades por día
            this.actividadesPorDia = this.actividades.reduce((acc, actividad) => {
              const fecha = actividad.fecha;
              if (!acc[fecha]) {
                acc[fecha] = [];
              }
              acc[fecha].push(actividad);
              return acc;
            }, {});

            // Encuentra el objeto 'event' en attrs y reemplaza su propiedad 'dates'
            const eventAttr = this.attrs.find((attr) => attr.key === "event");
            if (eventAttr) {
              eventAttr.dates = fechasDeActividades;
            }

            // Desplazamiento suave hacia el elemento con el id 'fecha'
            this.$nextTick(() => {
              const urlParams = new URLSearchParams(this.$route.query);
              const fecha = urlParams.get("fecha");
              console.log(fecha);

              const elemento = document.getElementById(fecha);
              if (elemento) {
                console.log("El elemento existe");

                // Ajusta la posición de desplazamiento para tener en cuenta la altura de la cabecera
                const posicionAjustada = elemento.getBoundingClientRect().top + window.pageYOffset - 120;

                // Desplazamiento suave hacia la posición ajustada
                window.scrollTo({top: posicionAjustada, behavior: "smooth"});
              } else {
                console.log("El elemento no existe");
              }
            });
          })
          .catch((error) => {
            console.error("Error al obtener los datos:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      onDayClick(dateObj) {
        event.preventDefault();
        const date = dateObj.date;
        console.log(date);
        const fechaFormateada = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        const elemento = document.getElementById(fechaFormateada);
        if (elemento) {
          const posicionAjustada = elemento.getBoundingClientRect().top + window.pageYOffset - 120;
          window.scrollTo({top: posicionAjustada, behavior: "smooth"});
          console.log("hay elemento");
        } else {
          console.log("no hay elemento");
        }
      },
    },
  };
</script>
<style scoped>
  .actividad-item h2 {
    background-color: #8b2119;
    color: #fff;
    font-size: 25px;
    line-height: 33px;
    padding: 0px 20px;
    padding-bottom: 5px;
    max-width: 170px;
    text-align: center;
    margin-top: 25px;
  }

  .actividad {
    margin-top: 20px;
    background-color: #f4f1e7;
    padding: 20px;
  }

  .actividad h3 {
    font-weight: bold;
  }

  .datos_actividad p {
    font-size: 14px;
    margin: 4px 0px;
  }

  .datos_actividad p::first-letter {
    text-transform: capitalize;
  }

  .estado_aforo span {
    background-color: darkgoldenrod;
    padding: 2px 10px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    width: 100%;
    max-width: 220px;
    font-size: 12px;
    letter-spacing: 1px;
    border-radius: 5px;
  }

  .estado_aforo {
    position: absolute;
    top: -10px;
    left: -13px;
  }
</style>
